/*
 * OPUS カートのセット保護
 * 「セット番号」が付いたカート行（Tシャツ本体＋オプション）は、
 *  - 数量を変更できないようにする（価格区分や追加料金の数量がずれるのを防ぐ）
 *  - 削除するとセット全体をまとめて削除する
 * Dawn系テーマのカートページ・カートドロワーで動きます。
 */
(() => {
  'use strict';
  const KEY = 'セット番号';
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function setRef(row) {
    const dt = Array.from(row.querySelectorAll('dt')).find((d) => d.textContent.replace(/[:：\s]/g, '') === KEY);
    return dt && dt.nextElementSibling ? dt.nextElementSibling.textContent.trim() : '';
  }

  function enhance() {
    document.querySelectorAll('.cart-item').forEach((row) => {
      if (row.dataset.opusSet) return;
      const ref = setRef(row);
      if (!ref) return;
      row.dataset.opusSet = ref;
      const qi = row.querySelector('quantity-input');
      if (qi) {
        const input = qi.querySelector('input');
        const fixed = document.createElement('p');
        fixed.className = 'opus-set-qty';
        fixed.innerHTML = `数量 ${input ? input.value : ''}<br><small>セット商品のため数量は変更できません。変更する場合は削除して、商品ページから再度ご注文ください。</small>`;
        qi.style.display = 'none';
        qi.insertAdjacentElement('afterend', fixed);
      }
    });
  }

  async function removeSet(ref) {
    const cart = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
    const updates = {};
    cart.items.forEach((it) => {
      if (it.properties && it.properties[KEY] === ref) updates[it.key] = 0;
    });
    if (!Object.keys(updates).length) return;
    await fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates }),
    });
    window.location.reload();
  }

  // 削除ボタン：セット全体を削除する（テーマ側の処理より先に受け取る）
  document.addEventListener(
    'click',
    (e) => {
      const btn = e.target.closest('cart-remove-button, .cart-remove-button, [id^="Remove-"], [id^="CartDrawer-Remove-"]');
      if (!btn) return;
      const row = btn.closest('.cart-item');
      const ref = row && (row.dataset.opusSet || setRef(row));
      if (!ref) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      row.style.opacity = '.4';
      removeSet(ref).catch(() => window.location.reload());
    },
    true
  );

  const style = document.createElement('style');
  style.textContent = '.opus-set-qty{margin:0;font-size:1.3rem;line-height:1.6}.opus-set-qty small{display:block;color:rgba(var(--color-foreground),.65);font-size:1.15rem;max-width:22rem}';
  document.head.appendChild(style);

  enhance();
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      enhance();
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
